<template>
	<div class="hello_container">
		<div class="swiper_container">
			<el-carousel class="swiper_list" :interval="swiperSpeed" arrow="never">
				<el-carousel-item v-for="(item, index) in swiperList" :key="index">
					<div class="swiper_item">
						<div class="slogan-box">
							<span class="h6">{{ item.title }}</span>
							<span class="h1">{{ item.subTitle }}</span>
							<span class="h1">{{ item.thirdTitle }}</span>
							<div class="btn-box" v-if="isHideForTest">
								<button class="btn-1" @click="openDemoDialog(true)">
									{{ $t('index.btn_demo_show') }} <img src="@/assets/static/imgs/common/m/arrow-blue-m.png" alt="">
								</button>
								<button class="btn-2" @click="openFormDialog(true)">
									{{ $t('index.btn_scheme') }} <img src="@/assets/static/imgs/common/m/arrow-white-m.png" alt="">
								</button>
							</div>
						</div>

						<div class="banner-icon-around-box">
							<div class="around-box-pub around-box1">
								<ul class="line1">
									<li v-for="(item, index) in aroundIcons.line_1" :key="'line_1_' + index">
										<img v-lazy="item.icon" alt="ICON" />
									</li>
								</ul>
							</div>

							<div class="around-box-pub around-box2">
								<ul class="line2">
									<li v-for="(item, index) in aroundIcons.line_2" :key="'line_2_' + index">
										<img v-lazy="item.icon" alt="ICON" />
									</li>
								</ul>
							</div>

							<div class="around-box-pub around-box3">
								<ul class="line3">
									<li v-for="(item, index) in aroundIcons.line_3" :key="'line_3_' + index">
										<img v-lazy="item.icon" alt="ICON" />
									</li>
								</ul>
							</div>
						</div>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>

		<!-- DEMO -->
		<DemoDialogMobile />

		<!-- CONTACT FORM -->
		<el-dialog 
			:visible.sync="$store.state.isShowFormDialog" 
			:close-on-click-modal="false" 
			:close-on-press-escape="false" 
			custom-class="custom-dialog custom-dialog-contact-form">
			<div class="form-area">
				<div class="down-area infos" v-if="false">
					<div class="tel-area-box">
						<div class="tel-area">
							<div class="postion">
								<img src="@/assets/static/imgs/common/m/icon-tel.png" alt="">
								<span class="download">{{ $t('index.right_pop.contact_us_tel_tips') }}</span>
							</div>
							<div class="tel-account rwft">
								{{ $t('index.right_pop.contact_us_tel') }}
							</div>
						</div>
	
						<div class="tel-area">
							<div class="postion">
								<img src="@/assets/static/imgs/common/m/icon-linkin.png" alt="">
								<span class="download">{{ $t('index.right_pop.contact_us_linkin_tips') }}</span>
							</div>
							<div class="tel-account rwft">
								{{ $t('index.right_pop.contact_us_linkin') }}
							</div>
						</div>
					</div>

					<div class="tel-area">
						<div class="postion">
							<img src="@/assets/static/imgs/common/m/icon-email.png" alt="">
							<span class="download">{{ $t('index.right_pop.contact_us_f') }}</span>
						</div>
						<div class="tel-account">
							{{ $t('index.right_pop.contact_us_wx') }}
						</div>
					</div>
				</div>

				<div class="down-area el-form-wrapper" v-if="false">
					<el-form ref="form" :model="form" :rules="rules">
						<div>
							<el-form-item prop="name">
								<el-input 
									v-model="form.name" 
									:placeholder="$t('index.business_cooperation_form_placeholder_name')"></el-input>
							</el-form-item>

							<el-form-item prop="phone" class="phone-input-sty">
								<el-input 
									v-if="false" 
									v-model="form.phone" 
									:placeholder="$t('index.business_cooperation_form_placeholder_phone')"></el-input>
								<vue-phone-number-input 
									v-model="form.phone" 
									:default-country-code="countryCode" 
									@update="onUpdate" 
									id="midPhone" />
							</el-form-item>

							<el-form-item prop="company">
								<el-input 
									v-model="form.company" 
									:placeholder="$t('index.business_cooperation_form_placeholder_company')"></el-input>
							</el-form-item>

							<el-form-item prop="email">
								<el-input 
									v-model="form.email" 
									:placeholder="$t('index.business_cooperation_form_placeholder_email')"></el-input>
							</el-form-item>
	
							<el-button type="primary" @click="submitForm('form')">
								{{ $t('index.business_cooperation_form_button') }}
							</el-button>
						</div>
					</el-form>
				</div>
				
				<img :src="newContactCard" alt="Contact Card" />
			</div>
		</el-dialog>
	</div>
</template>

<script>
/**
 * Mobile Components HelloWorld
 * @ is an alias to /src
 */
/* import bannerVideo1Poster  from '@/../public/static/video/banner/cover/banner-video-1-cover.jpg';
import bannerVideo1Src     from '@/../public/static/video/banner/media/banner-video-1.mp4';
import bannerVideo1AniUp   from '@/../public/static/video/banner/ani/ani-up.png';
import bannerVideo1AniDown from '@/../public/static/video/banner/ani/ani-down.png'; */
import { mapState }        from 'vuex';
import DemoDialogMobile    from '@/components/mobile/DemoDialog.vue';
import formRules           from '@/utils/formRules';
import { postFormJoinUs }  from '@/api/joinUsApi';
import { fetchAllGamesCached } from '@/api/gameDataLoader';
import {
	DEMO_DIALOG_IS_SHOW,
	FORM_DIALOG_IS_SHOW
} from '@/type/mutation';
import newContactCard from '@/assets/static/imgs/common/new-contact-card.png';

export default {
	name : 'HelloWorldMobile',
	props: {
		msg: String
	},
	components: {
		DemoDialogMobile
	},
	data() {
		return {
			// dialogDemoAreaVisible   : false,
			// dialogContactAreaVisible: false,
			newContactCard,
			iosDownloadUrl    : 'https://apps.apple.com/cn/app/apple-store/id375380948',
			androidDownloadUrl: 'https://play.google.com/store/apps/details?id=sg.bigo.live',
			swiperSpeed: 31536000000,
			swiperList : [
				{
					title      : 'Let Your Users Play Quality Games',
					subTitle   : 'HTML5',
					thirdTitle : '优质游戏提供商',
					subContents: [
						{
							url: 'https://cli.vuejs.org',
							tit: '0123456789'
						},
						{
							url: 'https://cli.vuejs.org',
							tit: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
						},
						{
							url: 'https://cli.vuejs.org',
							tit: 'abcdefghijklmnopqrstuvwxyz'
						},
						{
							url: 'https://cli.vuejs.org',
							tit: '0123456789'
						},
						{
							url: 'https://cli.vuejs.org',
							tit: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
						},
						{
							url: 'https://cli.vuejs.org',
							tit: 'abcdefghijklmnopqrstuvwxyz'
						}
					],
					/* bannerVideoOptions: {
						anis    : [
							bannerVideo1AniUp, 
							bannerVideo1AniDown
						],
						poster  : bannerVideo1Poster,
						src     : bannerVideo1Src,
						autoplay: true,
						loop    : true
					} */
				}
			],
			aroundIcons: {
                line_1: [], 
                line_2: [], 
                line_3: [] 
            },
			// About Phone
			results    : null,
			countryCode: 'US',
			form       : {
				name       : '',
				countryCode: '',// 86
				phone      : '',// 132 1234 5678
				company    : '',
				email      : ''
			},
			rules: {
				name   : formRules.nameRules(this),
				phone  : formRules.phoneRules(this),
				company: formRules.companyRules(this),
				email  : formRules.emailRules(this)
			}
		}
	},

	created() {
		if(this.isDeviceIos())
		{
			// console.log('=== Mobile__Components__HelloWorld__created__isDeviceIos <<<');
		}
		else if(this.isDeviceAndroid())
		{
			// console.log('=== Mobile__Components__HelloWorld__created__isDeviceAndroid <<<');
		}
	},

async mounted() {
    try {
        const games = await fetchAllGamesCached();
        this.aroundIcons.line_1 = this.$Common.getRandomItemsFromArray(games, 12);
        this.aroundIcons.line_2 = this.$Common.getRandomItemsFromArray(games, 12);
        this.aroundIcons.line_3 = this.$Common.getRandomItemsFromArray(games, 12);
    } catch (err) {
        console.error('=== Mobile__HelloWorld__load failed >>>', err);
    }
},

	methods: {
		openDemoDialog(value)
		{
			// this.$store.commit(DEMO_DIALOG_IS_SHOW, value);

			// console.log('=== Mobile__Components__HelloWorld__Click__Demo__Btn <<<');
			this.$store.commit(DEMO_DIALOG_IS_SHOW, value);

			/* if(this.isDeviceIos())
			{
				console.log('=== Mobile__Components__HelloWorld__openDemoDialog__isDeviceIos <<<');
				window.open(this.iosDownloadUrl);
			}
			else if(this.isDeviceAndroid())
			{
				console.log('=== Mobile__Components__HelloWorld__openDemoDialog__isDeviceAndroid <<<');
				window.open(this.androidDownloadUrl);
			} */
		},
		
		openFormDialog(value)
		{
			this.$store.commit(FORM_DIALOG_IS_SHOW, value);
		},

		closeFormDialog()
		{
			this.$store.commit(FORM_DIALOG_IS_SHOW, false);
		},

		// 获取电话信息的不同样式
		onUpdate(payload)
		{
			this.results = payload;
			// console.log('=== onUpdate__results >>>', this.results);

			// 让ERROR隐藏
			var botPhone = document.getElementById('midPhone');
			if(botPhone.nextElementSibling)
			{
				var nextElement = botPhone.nextElementSibling;
				nextElement.style.display = 'none';
			}

			this.$set(this.form, 'countryCode', this.results.countryCallingCode);// 86
			this.$set(this.form, 'phone', this.results.phoneNumber);             // 132 1234 5678
    	},

		// Submit Form
		async submitForm(formName)
		{
			this.$refs[formName].validate(async (valid) => {
				if(valid)
				{
					// Req
					/* console.log('=== submitForm__this__form >>>', this.form);
					return; */

					const res = await postFormJoinUs(this.form);
					// console.log('=== submitForm > res >>>', res);

					// 关闭输入弹窗
					this.closeFormDialog();
					this.$refs.form.resetFields();
					
					if(res && res.errCode === 0)
					{
						this.$message({
							type       : 'success',
							customClass: 'zdyElMsgMobile',
							message    : res.errMsg
						});
					}
					else if(res && res.errCode !== 0)
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsgMobile',
							message    : res.errMsg
						});
					}
					else
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsgMobile',
							message    : 'The operation failed. Please try again later~'
						});
					}
				}
				else
				{
					// console.log('=== this.form.phone >>>', this.form.phone);
					// console.log('=== this.form.valid >>>', valid);

					// 提交时：未输入手机号
					if(this.form.phone === null)
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsgMobile',
							message    : 'The operation failed. Please try again later~'
						});
					}
					else
					{
						// console.log('=== this.form.phone >>>', this.form.phone);
						const phoneNumberWithoutSpaces = this.form.phone.replace(/\s/g, '');// 移除所有空格
						const phoneNumberLength        = phoneNumberWithoutSpaces.length;
						if(phoneNumberLength < 5 || phoneNumberLength > 30)
						{
							this.$message({
								type       : 'warning',
								customClass: 'zdyElMsgMobile',
								message    : 'Phone format error~'
							});
						}
					}
					
					console.log('=== ERROR SUBMIT <<<');
					return false;
				}
			});
		}
	},
	computed: {
		// ES6展开合并运算符
		...mapState(['isHideForTest']),
		
		/* demoDialogVisible()
		{
			return this.isShowDemoDialog;
		},
		formDialogVisible()
		{
			return this.isShowFormDialog;
		} */
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
/deep/ .custom-dialog-contact-form{
	margin-top:10vh !important;
	width:686px;height:940px;
	border:2px solid #3E307C;border-radius:24px !important;
	/* background:#FFF url('@/assets/static/imgs/common/m/alert_bg.png') center top no-repeat;
	background-size:686px 300px; */
	background:#FFF;
	
	.el-dialog__header{
		height:45px;
		padding:20px 20px 10px;
		.el-dialog__headerbtn{
			top:10px;right:20px;
			width:32px;height:32px;
			padding:5px;
			.el-dialog__close{
				font-size:var(--com-base-fz-30);
			}
		}
	}
	.el-dialog__body{
		height:895px;
		padding:0px 30px;
		.form-area{
			height:100%;
			display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;
			padding-top:40px;
			img{
				width:100%;height:auto;
				border-radius:25px;
			}
			/* gap:30px; */
			.down-area-line-box{
				width:1px;height:325px;
				display:flex;justify-content:center;align-items:center;
				.down-area-line{
					width:1px;height:300px;
					margin-top:0px;
					border-left:1px solid #ededed;
				}
			}
			.down-area{
				display:flex;flex-direction:column;justify-content:center;align-items:flex-start;
				gap:35px;
				.tel-area{
					width:100%;
					padding-left:0;margin-top:unset;
					.postion{
						display:flex;justify-content:flex-start;align-items:center;
						img{
							width:40px;height:40px;
						}
						span{
							padding-left:10px;
							font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-28);color:var(--com-main-ft-FFF);font-style:normal;font-weight:bold;
						}
					}
					.tel-account{
						padding-left:50px;
						font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-28);color:#2F96FF;font-style:italic;font-weight:bold;
					}
					.rwft{
						color:#A2A9B3;font-style:normal;font-weight:normal;
					}
				}
			}
			.el-form-wrapper{
				width:100%;height:auto;
				margin-top:100px;
				.el-form{
					width:100%;height:auto;
					div{
						display:flex;flex-direction:column;justify-content:space-between;align-items:center;
						.el-form-item{
							margin-bottom:25px !important;
							.el-form-item__content{
								.el-input{
									font-size:var(--com-base-fz-26);
									input.el-input__inner{
										width:620px;height:94px;line-height:1;
										margin-right:0px;padding:0 25px;
										border-radius:18px !important;
										border:1px solid #F3F3F7;
										background:#FAFBFC;
										color:#5B77A1;
										transition:all .25s cubic-bezier(.645,.045,.355,1);
										&:focus{
											border-color:#409EFF;
											box-shadow:rgba(30, 144, 255,	0.7) 0px 0px 0px 2px;
										}
									}
									input.el-input__inner::placeholder{
										font-size:var(--com-base-fz-26);color:#C3C9D2;
									}
								}
								.el-form-item__error{
									padding-top:4px;
									font-size:var(--com-base-fz-18);
								}
							}
						}
						button{
							width:310px;height:88px;
							border-radius:44px;border:none;
							background:#1D55FF;
							span{
								font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-28);font-weight:normal;color:#FFF !important;
							}
						}
						.el-button{
							padding:12px 20px;
							font-size:var(--com-base-fz-18);
						}
					}
					.phone-input-sty, 
					.phone-input-sty .el-form-item__content,
					.vue-phone-number-input{
						flex-direction:row !important;
						.select-country-container{
							width:200px !important;min-width:200px;max-width:200px;
							margin-right:20px;
						}
						.country-selector{
							width:200px;height:94px !important;
							.country-selector__label{display:none;}
							.country-selector__country-flag{
								display:none;
								top:43px;left:20px;
							}
							.country-selector__input{
								height:94px;min-height:94px !important;line-height:90px;
								border:1px solid #F3F3F7;
								border-top-left-radius:18px !important;
								border-top-right-radius:18px !important;
								border-bottom-right-radius:18px !important;
								border-bottom-left-radius:18px !important;
								/* border-right:none !important; */
								font-size:var(--com-base-fz-26);color:#5B77A1;
								background:#FAFBFC;
								/* padding-left:70px; */
								transition:all .25s cubic-bezier(.645,.045,.355,1);
							}
							.country-selector__toggle{
								right:30px !important;
								svg.country-selector__toggle__arrow{
									width:30px !important;height:30px !important;
									path.arrow{
										fill:#5B77A1;
									}
								}
							}
							&.has-value{
								.country-selector__input{
									padding-top:unset !important;
								}
							}
						}
						.country-selector__label, .input-tel__label{
							display:none;
							top:-10px !important;left:11px !important;
							font-size:var(--com-base-fz-11);
						}
						.country-selector.has-value .country-selector__label{
							font-size:var(--com-base-fz-11);
						}
						.country-selector__list{
							left:0px;top:100px;
							width:620px !important;min-width:620px !important;
							height:250px !important;max-height:250px !important;
							border-radius:18px !important;
							background:#FAFBFC;
							.country-selector__list__item{
								width:620px !important;min-width:620px !important;
								background:transparent !important;
								font-size:var(--com-base-fz-24);color:#9DA2AB;
								.dots-text{
									color:#9DA2AB;
								}
								div{
									align-items:flex-start;
								}
							}
							.selected{
								.dots-text{
									color:#90A4C3;
								}
							}
						}			
						.input-tel{
							width:400px !important;height:94px !important;
							min-height:94px !important;
							.input-tel__input{
								height:inherit;min-height:48px !important;
								border:1px solid #F3F3F7;
								border-top-left-radius:18px !important;
								border-top-right-radius:18px !important;
    							border-bottom-right-radius:18px !important;
    							border-bottom-left-radius:18px !important;
								/* border-left:none !important; */
								font-size:var(--com-base-fz-26);color:#5B77A1;
								background:#FAFBFC;
								padding-top:unset !important;
							}
							input.input-tel__input::placeholder{
								font-size:var(--com-base-fz-26);color:#C3C9D2;
							}
						}
						.country-selector__list__item__flag-container{
							display:none;
						}
					}
				}
				.el-form>div{
					height:auto;
				}
			}
			.infos{
				display:flex;flex-direction:column;justify-content:flex-start;align-items:center;
				width:100%;height:auto;
				.tel-area-box{
					display:flex;justify-content:center;align-items:center;
					width:100%;
					.tel-area{
						width:50%;
						.postion{
							height:50px;
							img{
								width:40px;height:40px;
							}
							.download{
								font-size:var(--com-base-fz-28);
							}
						}
					}
				}
			}
		}
	}
}
.hello_container{
	position:relative;
	background:transparent;
	width:var(--com-base-container-wm);height:var(--com-base-top-container-h2m);
	.swiper_container{
		width:inherit;height:inherit;
		.swiper_list{
			width:inherit;height:inherit;
			/deep/ .el-carousel__container{
				width:var(--com-base-container-wm);height:var(--com-base-top-container-h2m);
				.el-carousel__item{
					height:inherit;
				}
			}
			/deep/ .el-carousel__indicators--horizontal{
				bottom:20px;left:0;transform:translateX(0%);
				button.el-carousel__button{
					display:none;
					opacity:.15;
					height:3px;
					border-radius:50px;
				}
				.is-active{
					button.el-carousel__button{
						display:none;
						opacity:1;
						background:linear-gradient(var(--gradient-direction), var(--gradient-color-start), var(--gradient-color-end));
					}
				}
			}
			.swiper_item{
				width:inherit;height:inherit;
				padding-top:160px;
				.slogan-box{
					width:100%;
					padding-left:0px;
					span{display:block;}
					span.h6{
						margin:0;margin-bottom:15px;padding-left:60px;
						font-size:var(--com-base-fz-28);color:#FFF;font-style:italic;
					}
					span.h1{
						margin:0;padding-left:60px;
						font-size:var(--com-base-fz-60);color:#FFF;font-weight:bold;
						line-height:1;
					}
					.btn-box{
						display:flex;justify-content:center;align-items:center;
						margin-top:75px;
						button{
							width:310px;height:90px;
							border-radius:50px;border:none;outline:none;
							font-size:var(--com-base-fz-36);text-align:center;font-weight:bold;
							cursor:pointer;
							img{
								width:26px;height:22px;
							}
						}
						button.btn-1{
							background:#FFF;color:#1D55FF;
							margin-right:25px;
						}
						button.btn-2{
							background:#1D55FF;color:#FFF;
						}
					}
				}
				.banner-icon-around-box{
					z-index:2;
					position:absolute;left:0;right:0;bottom:190px;margin:auto;
					width:var(--com-base-container-wm);height:500px;
					.around-box-pub{
						padding:0;
						transform-style:preserve-3d;
						perspective:1000px;perspective-origin:50% 50%;
					}
					.around-box1{margin:100px auto 0 auto;width:300px;height:88px;}
					.around-box2{margin:60px auto 0 auto;width:200px;height:83px;}
					.around-box3{margin:60px auto 0 auto;width:200px;height:83px;}
					ul{margin:0 auto;position:relative;transform-style:preserve-3d;}/* transform:rotateX(30deg); */
					ul.line1{animation:move 35s linear infinite;}
					ul.line2{animation:move 25s linear infinite;}
					ul.line3{animation:move 15s linear infinite;}
					ul li{position:absolute;top:0;left:0;overflow:hidden;transition:1s all ease;}
					ul.line1, ul.line1 li, ul.line1 li img{width:100px;height:100px;}
					ul.line2, ul.line2 li, ul.line2 li img{width:95px;height:95px;}
					ul.line3, ul.line3 li, ul.line3 li img{width:90px;height:90px;}
					
					ul.line1 li, 
					ul.line2 li, 
					ul.line3 li{border-radius:22px;}
					ul.line1 li, ul.line1 li img,
					ul.line2 li, ul.line2 li img{box-shadow:0 5px 40px 0 rgba(171, 89, 238, 0.6);}
					ul.line3 li, ul.line3 li img{box-shadow:0 5px 20px 0 rgba(171, 89, 238, 0.6);}

					/* ul li:hover img{width:120px;height:220px;} */
					ul.line1 li:nth-child(1) {transform:rotateY(30deg)  translateZ(270px);}
					ul.line1 li:nth-child(2) {transform:rotateY(60deg)  translateZ(270px);}
					ul.line1 li:nth-child(3) {transform:rotateY(90deg)  translateZ(270px);}
					ul.line1 li:nth-child(4) {transform:rotateY(120deg) translateZ(270px);}
					ul.line1 li:nth-child(5) {transform:rotateY(150deg) translateZ(270px);}
					ul.line1 li:nth-child(6) {transform:rotateY(180deg) translateZ(270px);}
					ul.line1 li:nth-child(7) {transform:rotateY(210deg) translateZ(270px);}
					ul.line1 li:nth-child(8) {transform:rotateY(240deg) translateZ(270px);}
					ul.line1 li:nth-child(9) {transform:rotateY(270deg) translateZ(270px);}
					ul.line1 li:nth-child(10){transform:rotateY(300deg) translateZ(270px);}
					ul.line1 li:nth-child(11){transform:rotateY(330deg) translateZ(270px);}
					ul.line1 li:nth-child(12){transform:rotateY(0deg)   translateZ(270px);}

					ul.line2 li:nth-child(1) {transform:rotateY(30deg)  translateZ(240px);}
					ul.line2 li:nth-child(2) {transform:rotateY(60deg)  translateZ(240px);}
					ul.line2 li:nth-child(3) {transform:rotateY(90deg)  translateZ(240px);}
					ul.line2 li:nth-child(4) {transform:rotateY(120deg) translateZ(240px);}
					ul.line2 li:nth-child(5) {transform:rotateY(150deg) translateZ(240px);}
					ul.line2 li:nth-child(6) {transform:rotateY(180deg) translateZ(240px);}
					ul.line2 li:nth-child(7) {transform:rotateY(210deg) translateZ(240px);}
					ul.line2 li:nth-child(8) {transform:rotateY(240deg) translateZ(240px);}
					ul.line2 li:nth-child(9) {transform:rotateY(270deg) translateZ(240px);}
					ul.line2 li:nth-child(10){transform:rotateY(300deg) translateZ(240px);}
					ul.line2 li:nth-child(11){transform:rotateY(330deg) translateZ(240px);}
					ul.line2 li:nth-child(12){transform:rotateY(0deg)   translateZ(240px);}

					ul.line3 li:nth-child(1) {transform:rotateY(30deg)  translateZ(210px);}
					ul.line3 li:nth-child(2) {transform:rotateY(60deg)  translateZ(210px);}
					ul.line3 li:nth-child(3) {transform:rotateY(90deg)  translateZ(210px);}
					ul.line3 li:nth-child(4) {transform:rotateY(120deg) translateZ(210px);}
					ul.line3 li:nth-child(5) {transform:rotateY(150deg) translateZ(210px);}
					ul.line3 li:nth-child(6) {transform:rotateY(180deg) translateZ(210px);}
					ul.line3 li:nth-child(7) {transform:rotateY(210deg) translateZ(210px);}
					ul.line3 li:nth-child(8) {transform:rotateY(240deg) translateZ(210px);}
					ul.line3 li:nth-child(9) {transform:rotateY(270deg) translateZ(210px);}
					ul.line3 li:nth-child(10){transform:rotateY(300deg) translateZ(210px);}
					ul.line3 li:nth-child(11){transform:rotateY(330deg) translateZ(210px);}
					ul.line3 li:nth-child(12){transform:rotateY(0deg)   translateZ(210px);}
				}
				.banner-bg-circle-box{
					z-index:1;
					position:absolute;right:65px;bottom:160px;
					width:320px;height:320px;
					animation:aniRotateRight 10s linear infinite;
					img{width:inherit;height:inherit;}
				}
				.banner-video-1-box{
					z-index:2;
					position:absolute;right:10px;bottom:50px;
					width:622px;height:358px;
					border:9px solid #fff;border-radius:27px;box-shadow:0 3px 18px 0 rgba(0,0,0,.1);
					cursor:pointer;
					video{width:100%;height:100%;border-radius:19px;}
				}
				.banner-video-ani-box{
					position:absolute;top:0;right:0;bottom:0;
					width:622px;height:var(--com-base-top-container-h1);
					.ani-up-c0{
						position:absolute;top:30px;right:53px;
						width:493px;height:247px;
						opacity:0;z-index:3;
						-webkit-animation:aniUp-c0 4s ease infinite;animation:aniUp-c0 4s ease infinite;
						pointer-events:none;
						img{width:inherit;height:inherit;}
					}
					.ani-down-c0{
						position:absolute;right:0;bottom:49px;
						width:660px;height:115px;
						opacity:0;z-index:3;
						-webkit-animation:aniDown-c0 4s ease infinite;animation:aniDown-c0 4s ease infinite;
						pointer-events:none;
						img{width:inherit;height:inherit;}
					}
				}
			}
		}
	}
}

@keyframes move{
    0%  {transform:rotateY(0deg);}
    10% {transform:rotateY(36deg);}
    20% {transform:rotateY(72deg);}
    30% {transform:rotateY(108deg);}
    40% {transform:rotateY(144deg);}
    50% {transform:rotateY(180deg);}
    60% {transform:rotateY(216deg);}
    70% {transform:rotateY(252deg);}
    80% {transform:rotateY(288deg);}
    90% {transform:rotateY(324deg);}
    100%{transform:rotateY(360deg);}
}
@keyframes aniRotateRight{
	0%{
		-webkit-transform:rotate(0deg);
		transform:rotate(0deg);
	}
	50%{
		-webkit-transform:rotate(180deg);
		transform:rotate(180deg);
	}
	100%{
		-webkit-transform:rotate(1turn);
		transform:rotate(1turn);
	}
}
@keyframes aniUp-c0{
	0%{
		top:30px;
		opacity:0;
	}
	50%{
		top:90px;
		opacity:1;
	}
	75%{
		top:90px;
		opacity:1;
	}
	100%{
		top:90px;
		opacity:0;
	}
}
@keyframes aniDown-c0{
	0%{
		bottom:-30px;
		opacity:0;
	}
	50%{
		bottom:-5px;
		opacity:1;
	}
	75%{
		bottom:-5px;
		opacity:1;
	}
	100%{
		bottom:-5px;
		opacity:0;
	}
}
</style>
